import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

export default function ProtectedRoute({ role, children }) {
  const { user, loading } = useAuth();
  const loc = useLocation();

  if (loading) return <div className="p-4">Loading...</div>;

  if (!user) {
    return <Navigate to={`/${role}/login`} replace state={{ from: loc }} />;
  }
  if (user.role !== role) {
    return <Navigate to={`/${user.role}/dashboard`} replace />;
  }
  return children;
}
